exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parameters-prompt-editor-container {\n  position: relative;\n}\n.parameters-prompt-editor-container .open-editor-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: -3px;\n  right: 0;\n}\n.parameters-prompt-editor-container .open-editor-button span {\n  font-size: 12px;\n  padding-top: 1px;\n}\n", ""]);

// exports
